  define(function uiText() {
  'use strict';

  // @TODO: Convert entire object to service so that
  // we can inject 'gettext' dependency. Defining the
  // gettext function here is a work-aroundthe global gettext
  // function because on load gettext is undefined.
  function gettext(phrase) {
    return phrase;
  }

  // eslint-disable max-len
  var text = {
    TEACHER: {
      customerSupport: {
        backButtonLabel: gettext('Dashboard'),
        messagePlaceholder: gettext('Type your message here.')
      },
      passwordModal: {
        header: gettext('Teacher Access'),
        subheader: gettext('Please enter your password to access your teacher account.'),
        placeholders: {
          password: gettext('Password')
        }
      },
      legal: {
        centerTitle: {
          terms: gettext('Terms and Conditions'),
          privacy: gettext('Privacy Policy')
        },
        backButtonLabel: gettext('Dashboard')
      },
      myProfile: {
        backButtonLabel: gettext('Dashboard'),
        centerTitle: gettext('My Profile'),
        myProfileContainer: {
          cancelButtonLabel: gettext('Cancel My Account')
        }
      },
      updateAccount: {
        backButtonLabel: {
          name: gettext('My Profile'),
          password: gettext('My Profile'),
          email: gettext('My Profile'),
          'phone-number': gettext('My Profile'), // state name is 'phone-number'
          cancel: gettext('My Profile')
        },
        centerTitle: {
          name: gettext('Change Name'),
          password: gettext('Change Password'),
          email: gettext('Change Email'),
          'phone-number': gettext('Change Phone Number'), // state name is 'phone-number'
          cancel: gettext('Cancel Account')
        },
        changePassword: {
          placeholders: {
            old: gettext('Current Password'),
            new: gettext('New Password'),
            confirmNew: gettext('Confirm New Password')
          },
          subheader: gettext('Change your login password.')
        },
        changeEmail: {
          placeholders: {
            old: gettext('Current Email'),
            new: gettext('New Email'),
            confirmNew: gettext('Confirm New Email')
          }
        },
        changePhoneNumber: {
          placeholders: {
            old: gettext('Current Phone Number'),
            new: gettext('New Phone Number'),
            confirmNew: gettext('Confirm New Phone Number')
          }
        },
        changeName: {
          placeholders: {
            firstName: gettext('First Name'),
            lastName: gettext('Last Name')
          }
        },
        cancelSubscription: {
          passwordModal: {
            header: gettext('Teacher Access'),
            subheader: gettext('Please enter your password to cancel your teacher account.'),
            placeholders: {
              password: gettext('Password')
            }
          }
        }
      }
    },
    TEACHER_EMS: {
      customerSupport: {
        backButtonLabel: gettext('Dashboard'),
        messagePlaceholder: gettext('Type your message here.')
      },
      passwordModal: {
        header: gettext('Teacher Access'),
        subheader: gettext('Please enter your password to access your teacher account.'),
        placeholders: {
          password: gettext('Password')
        }
      },
      legal: {
        centerTitle: {
          terms: gettext('Terms and Conditions'),
          privacy: gettext('Privacy Policy')
        },
        backButtonLabel: gettext('Dashboard')
      },
      myProfile: {
        backButtonLabel: gettext('Dashboard'),
        centerTitle: gettext('My Profile'),
        myProfileContainer: {
          cancelButtonLabel: gettext('Cancel My Account')
        }
      },
      updateAccount: {
        backButtonLabel: {
          name: gettext('My Profile'),
          password: gettext('My Profile'),
          email: gettext('My Profile'),
          'phone-number': gettext('My Profile'), // state name is 'phone-number'
          cancel: gettext('My Profile')
        },
        centerTitle: {
          name: gettext('Change Name'),
          password: gettext('Change Password'),
          email: gettext('Change Email'),
          'phone-number': gettext('Change Phone Number'), // state name is 'phone-number'
          cancel: gettext('Cancel Account')
        },
        changeEmail: {
          placeholders: {
            old: gettext('Current Email'),
            new: gettext('New Email'),
            confirmNew: gettext('Confirm New Email')
          }
        },
        changePhoneNumber: {
          placeholders: {
            old: gettext('Current Phone Number'),
            new: gettext('New Phone Number'),
            confirmNew: gettext('Confirm New Phone Number')
          }
        },
        cancelSubscription: {}
      }
    },
    PARENT_PAID: {},
    PARENT_FREE: {},
    CHILD_AT_SCHOOL: {},
    EMS_STUDENT_AT_SCHOOL: {},
    CHILD_PAID: {
      customerSupport: {
        backButtonLabel: gettext('Parent Settings'),
        messagePlaceholder: gettext('Type your message here.')
      },
      passwordModal: {
        header: gettext('Parent Settings'),
        subheader: gettext('Please enter your password to access Parent Settings.'),
        placeholders: {
          password: gettext('Password')
        }
      },
      legal: {
        centerTitle: {
          terms: gettext('Terms and Conditions'),
          privacy: gettext('Privacy Policy')
        },
        backButtonLabel: gettext('Parent Settings')
      },
      myProfile: {
        backButtonLabel: gettext('Parent Settings'),
        centerTitle: gettext('Manage Account'),
        myProfileContainer: {
          cancelButtonLabel: gettext('Cancel My Subscription')
        }
      },
      updateAccount: {
        backButtonLabel: {
          name: gettext('Manage Account'),
          password: gettext('Manage Account'),
          email: gettext('Manage Account'),
          'phone-number': gettext('Manage Account'), // state name is 'phone-number'
          cancel: gettext('Manage Account')
        },
        centerTitle: {
          name: gettext('Change Name'),
          password: gettext('Change Password'),
          email: gettext('Change Email Address'),
          'phone-number': gettext('Change Phone Number'), // state name is 'phone-number'
          cancel: gettext('Cancel Subscription')
        },
        changePassword: {
          placeholders: {
            old: gettext('Current Password'),
            new: gettext('New Password'),
            confirmNew: gettext('Confirm New Password')
          },
          subheader: gettext('You are going to change your login and parental password.')
        },
        changeEmail: {
          placeholders: {
            old: gettext('Current Email'),
            new: gettext('New Email'),
            confirmNew: gettext('Confirm New Email')
          }
        },
        changePhoneNumber: {
          placeholders: {
            old: gettext('Current Phone Number'),
            new: gettext('New Phone Number'),
            confirmNew: gettext('Confirm New Phone Number')
          }
        },
        changeName: {
          placeholders: {
            firstName: gettext('First Name'),
            lastName: gettext('Last Name')
          }
        },
        cancelSubscription: {
          passwordModal: {
            header: gettext('Cancel Subscription'),
            subheader: gettext('Please enter your password to cancel your account.'),
            placeholders: {
              password: gettext('Password')
            }
          },
          subheader: gettext('Please tell us why you are cancelling your subscription'),
          optionalText: gettext(' (optional)'),
          keepButton: gettext('Keep My Subscription')
        }
      },
      manageSubscription: {
        backButtonLabel: gettext('Manage Account'),
        centerTitle: gettext('Manage Subscription')
      }
    },
    CHILD_PAID_EMS_LINKED: {
      customerSupport: {
        backButtonLabel: gettext('Parent Settings'),
        messagePlaceholder: gettext('Type your message here.')
      },
      passwordModal: {
        header: gettext('Parent Settings'),
        subheader: gettext('Please enter your password to access Parent Settings.'),
        placeholders: {
          password: gettext('Password')
        }
      },
      legal: {
        centerTitle: {
          terms: gettext('Terms and Conditions'),
          privacy: gettext('Privacy Policy')
        },
        backButtonLabel: gettext('Parent Settings')
      },
      myProfile: {
        backButtonLabel: gettext('Parent Settings'),
        centerTitle: gettext('Manage Account'),
        myProfileContainer: {
          cancelButtonLabel: gettext('Cancel My Subscription')
        }
      },
      updateAccount: {
        backButtonLabel: {
          name: gettext('Manage Account'),
          password: gettext('Manage Account'),
          email: gettext('Manage Account'),
          'phone-number': gettext('Manage Account'), // state name is 'phone-number'
          cancel: gettext('Manage Account')
        },
        centerTitle: {
          name: gettext('Change Name'),
          password: gettext('Change Password'),
          email: gettext('Change Email Address'),
          'phone-number': gettext('Change Phone Number'), // state name is 'phone-number'
          cancel: gettext('Cancel Subscription')
        },
        changePassword: {
          placeholders: {
            old: gettext('Current Password'),
            new: gettext('New Password'),
            confirmNew: gettext('Confirm New Password')
          },
          subheader: gettext('You are going to change your login and parental password.')
        },
        changeEmail: {
          placeholders: {
            old: gettext('Current Email'),
            new: gettext('New Email'),
            confirmNew: gettext('Confirm New Email')
          }
        },
        changePhoneNumber: {
          placeholders: {
            old: gettext('Current Phone Number'),
            new: gettext('New Phone Number'),
            confirmNew: gettext('Confirm New Phone Number')
          }
        },
        changeName: {
          placeholders: {
            firstName: gettext('First Name'),
            lastName: gettext('Last Name')
          }
        },
        cancelSubscription: {
          passwordModal: {
            header: gettext('Cancel Subscription'),
            subheader: gettext('Please enter your password to cancel your account.'),
            placeholders: {
              password: gettext('Password')
            }
          },
          subheader: gettext('Please tell us why you are cancelling your subscription'),
          optionalText: gettext(' (optional)'),
          keepButton: gettext('Keep My Subscription')
        }
      },
      manageSubscription: {
        backButtonLabel: gettext('Manage Account'),
        centerTitle: gettext('Manage Subscription')
      }
    },
    CHILD_PAID_LIMITED_EMS_LINKED: {
      customerSupport: {
        backButtonLabel: gettext('Parent Settings'),
        messagePlaceholder: gettext('Type your message here.')
      },
      passwordModal: {
        header: gettext('Parent Settings'),
        subheader: gettext('Please enter your password to access Parent Settings.'),
        placeholders: {
          password: gettext('Password')
        }
      },
      legal: {
        centerTitle: {
          terms: gettext('Terms and Conditions'),
          privacy: gettext('Privacy Policy')
        },
        backButtonLabel: gettext('Parent Settings')
      },
      myProfile: {
        backButtonLabel: gettext('Parent Settings'),
        centerTitle: gettext('Manage Account'),
        myProfileContainer: {
          cancelButtonLabel: gettext('Cancel My Subscription')
        }
      },
      updateAccount: {
        backButtonLabel: {
          name: gettext('Manage Account'),
          password: gettext('Manage Account'),
          email: gettext('Manage Account'),
          'phone-number': gettext('Manage Account'), // state name is 'phone-number'
          cancel: gettext('Manage Account')
        },
        centerTitle: {
          name: gettext('Change Name'),
          password: gettext('Change Password'),
          email: gettext('Change Email Address'),
          'phone-number': gettext('Change Phone Number'), // state name is 'phone-number'
          cancel: gettext('Cancel Subscription')
        },
        changePassword: {
          placeholders: {
            old: gettext('Current Password'),
            new: gettext('New Password'),
            confirmNew: gettext('Confirm New Password')
          },
          subheader: gettext('You are going to change your login and parental password.')
        },
        changeEmail: {
          placeholders: {
            old: gettext('Current Email'),
            new: gettext('New Email'),
            confirmNew: gettext('Confirm New Email')
          }
        },
        changePhoneNumber: {
          placeholders: {
            old: gettext('Current Phone Number'),
            new: gettext('New Phone Number'),
            confirmNew: gettext('Confirm New Phone Number')
          }
        },
        changeName: {
          placeholders: {
            firstName: gettext('First Name'),
            lastName: gettext('Last Name')
          }
        },
        cancelSubscription: {
          passwordModal: {
            header: gettext('Cancel Subscription'),
            subheader: gettext('Please enter your password to cancel your account.'),
            placeholders: {
              password: gettext('Password')
            }
          },
          subheader: gettext('Please tell us why you are cancelling your subscription'),
          optionalText: gettext(' (optional)'),
          keepButton: gettext('Keep My Subscription')
        }
      },
      manageSubscription: {
        backButtonLabel: gettext('Manage Account'),
        centerTitle: gettext('Manage Subscription')
      }
    },
    CHILD_PAID_CLASS_LINKED: {
      customerSupport: {
        backButtonLabel: gettext('Parent Settings'),
        messagePlaceholder: gettext('Type your message here.')
      },
      passwordModal: {
        header: gettext('Parent Settings'),
        subheader: gettext('Please enter your password to access Parent Settings.'),
        placeholders: {
          password: gettext('Password')
        }
      },
      legal: {
        centerTitle: {
          terms: gettext('Terms and Conditions'),
          privacy: gettext('Privacy Policy')
        },
        backButtonLabel: gettext('Parent Settings')
      },
      myProfile: {
        backButtonLabel: gettext('Parent Settings'),
        centerTitle: gettext('Manage Account'),
        myProfileContainer: {
          cancelButtonLabel: gettext('Cancel My Subscription')
        }
      },
      updateAccount: {
        backButtonLabel: {
          name: gettext('Manage Account'),
          password: gettext('Manage Account'),
          email: gettext('Manage Account'),
          'phone-number': gettext('Manage Account'), // state name is 'phone-number'
          cancel: gettext('Manage Account')
        },
        centerTitle: {
          name: gettext('Change Name'),
          password: gettext('Change Password'),
          email: gettext('Change Email Address'),
          'phone-number': gettext('Change Phone Number'), // state name is 'phone-number'
          cancel: gettext('Cancel Subscription')
        },
        changePassword: {
          placeholders: {
            old: gettext('Current Password'),
            new: gettext('New Password'),
            confirmNew: gettext('Confirm New Password')
          },
          subheader: gettext('You are going to change your login and parental password.')
        },
        changeEmail: {
          placeholders: {
            old: gettext('Current Email'),
            new: gettext('New Email'),
            confirmNew: gettext('Confirm New Email')
          }
        },
        changePhoneNumber: {
          placeholders: {
            old: gettext('Current Phone Number'),
            new: gettext('New Phone Number'),
            confirmNew: gettext('Confirm New Phone Number')
          }
        },
        changeName: {
          placeholders: {
            firstName: gettext('First Name'),
            lastName: gettext('Last Name')
          }
        },
        cancelSubscription: {
          passwordModal: {
            header: gettext('Parent Settings'),
            subheader: gettext('Please enter your password to access Parent Settings.'),
            placeholders: {
              password: gettext('Password')
            }
          },
          subheader: gettext('Please tell us why you are cancelling your subscription'),
          optionalText: gettext(' (optional)'),
          keepButton: gettext('Keep My Subscription')
        }
      }
    },
    CHILD_FREE_CLASS_LINKED: {
      customerSupport: {
        backButtonLabel: gettext('Parent Settings'),
        messagePlaceholder: gettext('Type your message here.')
      },
      passwordModal: {
        header: gettext('Parent Settings'),
        subheader: gettext('Please enter your password to access Parent Settings.'),
        placeholders: {
          password: gettext('Password')
        }
      },
      legal: {
        centerTitle: {
          terms: gettext('Terms and Conditions'),
          privacy: gettext('Privacy Policy')
        },
        backButtonLabel: gettext('Parent Settings')
      },
      myProfile: {
        backButtonLabel: gettext('Parent Settings'),
        centerTitle: gettext('Manage Account'),
        myProfileContainer: {
          cancelButtonLabel: gettext('Cancel My Account')
        }
      },
      updateAccount: {
        backButtonLabel: {
          name: gettext('Manage Account'),
          password: gettext('Manage Account'),
          email: gettext('Manage Account'),
          'phone-number': gettext('Manage Account'), // state name is 'phone-number'
          cancel: gettext('Manage Account')
        },
        centerTitle: {
          name: gettext('Change Name'),
          password: gettext('Change Password'),
          email: gettext('Change Email Address'),
          'phone-number': gettext('Change Phone Number'), // state name is 'phone-number'
          cancel: gettext('Cancel Account')
        },
        changePassword: {
          placeholders: {
            old: gettext('Current Password'),
            new: gettext('New Password'),
            confirmNew: gettext('Confirm New Password')
          },
          subheader: gettext('You are going to change your login and parental password.')
        },
        changeEmail: {
          placeholders: {
            old: gettext('Current Email'),
            new: gettext('New Email'),
            confirmNew: gettext('Confirm New Email')
          }
        },
        changePhoneNumber: {
          placeholders: {
            old: gettext('Current Phone Number'),
            new: gettext('New Phone Number'),
            confirmNew: gettext('Confirm New Phone Number')
          }
        },
        changeName: {
          placeholders: {
            firstName: gettext('First Name'),
            lastName: gettext('Last Name')
          }
        },
        cancelSubscription: {
          passwordModal: {
            header: gettext('Parent Settings'),
            subheader: gettext('Please enter your password to access Parent Settings.'),
            placeholders: {
              password: gettext('Password')
            }
          },
          subheader: gettext('Please tell us why you are cancelling your account'),
          optionalText: gettext(' (optional)'),
          keepButton: gettext('Keep My Account')
        }
      }
    },
    CHILD_FREE: {
      customerSupport: {
        backButtonLabel: gettext('Parent Settings'),
        messagePlaceholder: gettext('Type your message here.')
      },
      passwordModal: {
        header: gettext('Parent Settings'),
        subheader: gettext('Please enter your password to access Parent Settings.'),
        placeholders: {
          password: gettext('Password')
        }
      },
      legal: {
        centerTitle: {
          terms: gettext('Terms and Conditions'),
          privacy: gettext('Privacy Policy')
        },
        backButtonLabel: gettext('Parent Settings')
      },
      myProfile: {
        backButtonLabel: gettext('Parent Settings'),
        centerTitle: gettext('Manage Account'),
        myProfileContainer: {
          cancelButtonLabel: gettext('Cancel My Account')
        }
      },
      updateAccount: {
        backButtonLabel: {
          name: gettext('Manage Account'),
          password: gettext('Manage Account'),
          email: gettext('Manage Account'),
          'phone-number': gettext('Manage Account'), // state name is 'phone-number'
          cancel: gettext('Manage Account')
        },
        centerTitle: {
          name: gettext('Change Name'),
          password: gettext('Change Password'),
          email: gettext('Change Email Address'),
          'phone-number': gettext('Change Phone Number'), // state name is 'phone-number'
          cancel: gettext('Cancel Account')
        },
        changePassword: {
          placeholders: {
            old: gettext('Current Password'),
            new: gettext('New Password'),
            confirmNew: gettext('Confirm New Password')
          },
          subheader: gettext('You are going to change your login and parental password.')
        },
        changeEmail: {
          placeholders: {
            old: gettext('Current Email'),
            new: gettext('New Email'),
            confirmNew: gettext('Confirm New Email')
          }
        },
        changePhoneNumber: {
          placeholders: {
            old: gettext('Current Phone Number'),
            new: gettext('New Phone Number'),
            confirmNew: gettext('Confirm New Phone Number')
          }
        },
        changeName: {
          placeholders: {
            firstName: gettext('First Name'),
            lastName: gettext('Last Name')
          }
        },
        cancelSubscription: {
          passwordModal: {
            header: gettext('Parent Settings'),
            subheader: gettext('Please enter your password to access Parent Settings.'),
            placeholders: {
              password: gettext('Password')
            }
          },
          subheader: gettext('Please tell us why you are cancelling your account'),
          optionalText: gettext(' (optional)'),
          keepButton: gettext('Keep My Account')
        }
      }
    }
  };

text.CHILD_PAID_LIMITED_CLASS_LINKED = text.CHILD_PAID_CLASS_LINKED;
text.CHILD_PAID_LIMITED = text.CHILD_PAID;
  // eslint-enable max-len

  function getUserText(userType) {
    if (userType.length > 0 && !text[userType]) {
      console.warn(
        'User Type could not be found. Could not get text for ' + userType
      );
      return [];
    }
    return text[userType];
  }

  return {
    getUserText: getUserText
  };
});
